import { createAction } from "@reduxjs/toolkit";
import { fleetManagerContextTypes } from "../../context/store/actions/fleetManagerContext.types";

export const toggleShowPedestrianInvitationFormAction = createAction
    (fleetManagerContextTypes.TOGGLE_SHOW_PEDESTRIAN_INVITATION_FORM);